// extracted by mini-css-extract-plugin
export var container = "_r6-0";
export var dotAnimation = "_r6-2";
export var dotsLoading = "_r6-1";